import React from "react";
import numbro from "numbro";

const PoItem = ({ index, poItem }) => {

    // Format currency from paisas to PKR with PKR prefix
    const formatCurrency = (paisas) => {
        const pkr = paisas / 100;
        return 'PKR ' + numbro(pkr).format({
            thousandSeparated: true,
            mantissa: 2
        });
    };

    return (<>
        <tr className="table-row">
            <td className="serial-num align-middle py-2">
                <span className="text-muted">{index + 1}</span>
            </td>
            <td className="primary-font align-middle py-2">
                <span className="sku-name">{poItem.sku_name}</span>
            </td>
            <td className="text-end text-black align-middle py-2">
                <div className="primary-font">
                    {formatCurrency(poItem.procurement_unit_price_paisas || 0)}
                </div>
                <div className="secondary-font">
                    per {poItem.procurement_label}
                </div>
            </td>
            <td className="align-middle py-2">
                <div className="d-flex align-items-baseline justify-content-end w-100">
                    <div className="text-end" style={{ width: '39%', flexShrink: 0 }}>
                        <div className="primary-font">
                            {numbro(poItem.procurement_units).format({ thousandSeparated: true })}
                        </div>
                        <div className="secondary-font">
                            {poItem.procurement_label}
                        </div>
                    </div>
                    <div
                        className="text-muted text-end"
                        style={{
                            fontSize: '16px',
                            lineHeight: '1',
                            fontWeight: 400,
                            width: '22%',
                            flexShrink: 0,
                            marginInline: '0px',
                        }}
                    >
                        =
                    </div>
                    <div className="text-end" style={{ width: '39%', flexShrink: 0 }}>
                        <div className="primary-font">
                            {numbro(poItem.selling_units).format({ thousandSeparated: true })}
                        </div>
                        <div className="secondary-font">
                            {poItem.selling_label}
                        </div>
                    </div>
                </div>
            </td>
            <td className="text-end align-middle py-2" style={{ whiteSpace: 'nowrap' }}>
                <span style={{ fontWeight: '600', color: '#000', fontSize: '16px' }}>
                    {formatCurrency(poItem.payable_paisas || 0)}
                </span>
            </td>
        </tr>
        <tr>
            <td colSpan={5} style={{ padding: 0 }}>
                <hr
                    className="my-0 mx-4"
                    style={{
                        height: '1px',
                        backgroundColor: '#616E7C',
                        border: 'none'
                    }}
                />
            </td>
        </tr>
    </>);
};

export default PoItem;
